import { Component, NgZone } from "@angular/core";
import { Events, IonicPage, NavController, NavParams } from "ionic-angular";
import { PinPadProvider } from "../../providers/pin-pad/pin-pad";
import { BluetoothSerial } from "@ionic-native/bluetooth-serial";
import { TransactionAlertProvider } from '../../providers/transaction-alert/transaction-alert';

enum PosStatus {
  Connected = "onRequestQposConnected",
  Disconnected = "onRequestQposDisconnected",
  InsertCard = "please insert/swipe/tap card",
  InsertPin = "please input pin on pos",
  UserCancel = ""
}

@IonicPage()
@Component({
  selector: "page-card-transactions",
  templateUrl: "card-transactions.html"
})
export class CardTransactionsPage {
  public list: Array<object> = [];
  private win: any;
  public mposConnected;
  private connectCount = 0;
  public printerStatus: any;
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    protected pinPad: PinPadProvider,
    protected bluetooth: BluetoothSerial,
    private zone: NgZone,
    private events: Events,
    private alert: TransactionAlertProvider
  ) {
    this.win = window;
    this.win.posResultData = {};
    this.win.posresult = data => {
     // console.log(data);
      this.setPosData(data);
      this.mposConnected = this.win.posResultData.connected;
      this.events.publish("status:changed", this.win.posResultData);
      this.zone.run(() => {
        this.checkConnection();
      });
    };

    if (this.win.printerStatus) {
      console.log("connected printer status");
      this.printerStatus = this.win.printerStatus.status;
    }
  }

  nextPage(data) {
    if (
      !this.win.posResultData.connected ||
      this.win.posResultData.connected === PosStatus.Disconnected
    ) {
    this.noConnection();
    } else {
    //  this.navCtrl.push("CardTransactionsDetailsPage", data);
      this.navigateCardPaymentPages(data)
    }
  }

  //this.mposConnected === '' || this.mposConnected === PosStatus.Disconnected
  private checkConnection() {
    if (
      !this.win.posResultData.connected ||
      this.win.posResultData.connected === PosStatus.Disconnected
    ) {
      if (this.connectCount === 0) {
        this.noConnection();
      }
    }
  }

  private noConnection() {
    this.connectCount++;
    this.pinPad.makeAlert({
      name: "notConnectAlert",
      title: "",
      message: ` <img src="../../assets/img/radio.svg" width="40" alt="image">\n  <h5>No Pinpad Connected</h5>\n <br>\n Your device has not been linked to any Pinpad, click on the "Link Pinpad"\n  button to continue.`,
      actionName: "Connect",
      backdrop: true,
      action: async () => {
        // const loading = this.pinPad.loading('Loading Connected Devices...');
        //loading.present();
        const devices = await this.bluetooth.list();
        const filteredDevices = devices.filter(device =>
          device.name.includes("FP")
        );
        if (!filteredDevices.length) {
          // loading.dismiss();
          this.connectBluetooth();
        } else {
          this.pinPad.deviceList(filteredDevices);
        }
      },
      popUp: true
    });
  }

  private connectBluetooth() {
    this.pinPad.makeAlert({
      name: "connectBluetooth",
      title: "",
      message: `Please make sure your bluetooth is on and pinpad device has been paired`,
      actionName: "Cancel",
      backdrop: true,
      action: () => {},
      popUp: true
    });
  }

  private setPosData(data) {
    if (data === PosStatus.Connected) {
      this.win.posResultData.connected = data;
    } else if (data === PosStatus.Disconnected) {
      this.connectCount = 0;
      this.win.posResultData.connected = data;
    } else if (data === PosStatus.InsertCard) {
      this.win.posResultData.insertAtm = data;
    } else if (data === PosStatus.UserCancel) {
      this.win.posResultData.cancel = data;
    } else if (data === PosStatus.InsertPin) {
      this.win.posResultData.insertPin = data;
    } else if (data.includes("ONLINE_DATA_PROCESS")) {
      const [maker, onlineData] = data.split(":");
      this.win.posResultData.online = onlineData;
      this.win.posResultData.send = 0;
    }
  }

  comingSoon() {
    this.alert.presentNormalAlert("Coming Soon");
  }

  navigateCardPaymentPages({type}) {
      switch(type) {
        case 'Cash Out Transaction': {
          this.navCtrl.push("CardTransactionsDetailsPage", {type});
        }
        break
        case 'Bank Transfer' : {
          this.navCtrl.push("PinpadMoneyTransferPage", {type});
        }
        break
        default: 
         return null;
      }
  }


  ionViewWillEnter() {
    this.checkConnection();
  }
}



// WEBPACK FOOTER //
// ./src/pages/card-transactions/card-transactions.ts